import React from 'react';
import './Background.css';

export default function Background({ imageUrl, gradient = true, blurClass }) {
  return (
    <div
      className="absolute inset-0 bg-cover bg-center background-root"
      style={{ '--bg-image': `url(${imageUrl})`, backgroundImage: `url(${imageUrl})` }}
    >
      {gradient && (
        <div className="background-gradient" />
      )}
      {blurClass && (
        <div className={`absolute inset-0 ${blurClass}`} />
      )}
    </div>
  );
}
